<template>
  <div>
    <change-pwd type="phone" @findSuccess="findSuccess" @changeCom="changeCurrentCom"></change-pwd>
  </div>
</template>
<script>
import ChangePwd from './ChangePwd.vue'
export default {
  name: 'WorkspaceJsonFindByPhone',
  components: { ChangePwd },
  methods: {
    findSuccess(res) {
      this.$emit('findSuccess', res)
    },
    changeCurrentCom(com, loginCom = true) {
      console.log('com :>> ', com);
      this.$emit('changeCom', com, loginCom)
    },
  },
}
</script>
